export * from './lib/drawing-manager/google-drawing-manager';

export * from './lib/google-drawing.module';
